import styled from 'styled-components'
import {primary} from '@modifi/colors'

export const LimitsValue = styled.span`
  color: ${primary};
`
